import { API } from "@/services"

export const THRESHOLDS_ENDPOINTS = {
  create(data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `thresholds`,
      method: 'POST',
      data,
    })
  },
  list(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `thresholds`,
      method: 'GET',
      params,
    })
  },
  update(id='',data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `thresholds/${id}`,
      method: 'PUT',
      data,
    })
  },
  findById(id='',params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `thresholds/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `thresholds/${id}`,
      method: 'DELETE',
      data,
    })
  },
}